import { api } from "../lib/api";
import { fmt, t } from "../lib/i18n";
import { Link, navigate } from "../lib/router";
import { h, resource } from "../lib/ui";
import { Async, Prio, TicketStatus } from "../shared/components";
import { Icon } from "../shared/icons";
import { PageHead } from "./app";

export function Overview() {
  const r = resource("admin.overview", () => api.get("/api/admin/overview"));
  return (
    <div class="stack loose">
      <PageHead title={t("admin.overview.title", { name: r.data?.me?.name?.split(" ")[0] ?? "" })} intro={t("admin.overview.intro", { date: fmt.date(new Date(), "long") })} />
      {Async(r, (d: any) => (
        <div class="stack loose">
          {d.revoked.length ? (
            <div class="alert-strip" role="alert">
              <Icon name="power" />
              <div class="stack tight grow">
                <strong>{t("admin.overview.revokedTitle", { count: d.revoked.length })}</strong>
                <span class="small">{t("admin.overview.revokedBody")}</span>
                <div class="row">
                  {d.revoked.map((home: any) => (
                    <Link class="btn small danger-outline" href={`/admin/homes/${home.id}`}>{home.code} · {fmt.relative(home.access_revoked_at)}</Link>
                  ))}
                </div>
              </div>
            </div>
          ) : null}

          <div class="kpis">
            <Link class="kpi" href="/admin/homes"><b>{d.homes.active}</b><span>{t("admin.overview.activeHomes")}</span></Link>
            <Link class="kpi" href="/admin/homes"><b>{d.homes.onboarding + d.homes.trial}</b><span>{t("admin.overview.onboarding")}</span></Link>
            <Link class={`kpi ${d.tickets.p1 ? "alert" : ""}`} href="/admin/tickets"><b>{d.tickets.p1}</b><span>{t("admin.overview.p1Open")}</span></Link>
            <Link class="kpi" href="/admin/tickets"><b>{d.tickets.to_triage}</b><span>{t("admin.overview.toTriage")}</span></Link>
            <Link class="kpi" href="/admin/tickets"><b>{d.tickets.awaiting_approval}</b><span>{t("admin.overview.awaitingCustomer")}</span></Link>
            <Link class="kpi" href="/admin/visits"><b>{d.visits.today}</b><span>{t("admin.overview.visitsToday", { week: d.visits.week })}</span></Link>
          </div>

          <div class="cols-2">
            <section class="panel">
              <div class="panel-head"><h2>{t("admin.overview.p1Title")}</h2><Link href="/admin/tickets" class="small">{t("common.viewAll")}</Link></div>
              {d.p1.length ? (
                <table class="table">
                  <tbody>
                    {d.p1.map((x: any) => (
                      <tr class="link" onClick={() => navigate(`/admin/tickets/${x.id}`)}>
                        <td style="width:48px"><Prio p="P1" /></td>
                        <td><span class="strong">{x.title}</span><span class="sub">{x.code} · {x.address_line1}</span></td>
                        <td class="right"><TicketStatus status={x.status} /><span class="sub">{fmt.relative(x.created_at)}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div class="empty"><span>{t("admin.overview.noP1")}</span></div>
              )}
            </section>

            <section class="panel">
              <div class="panel-head"><h2>{t("admin.overview.capacityTitle")}</h2></div>
              <div class="panel-body stack">
                {d.experts.length ? d.experts.map((e: any) => (
                  <div class={`capacity ${e.alert ? "alert" : ""}`}>
                    <div class="row between small"><span class="strong">{e.name}</span><span class="muted tabular">{t("admin.overview.homesOf", { n: e.homes, max: e.capacity })}</span></div>
                    <div class="bar"><i style={{ width: `${Math.min(100, (e.homes / e.capacity) * 100)}%` }} /></div>
                    {e.alert ? <span class="xs" style="color:var(--c-accent-text)">{t("admin.overview.hiringAlert")}</span> : null}
                  </div>
                )) : <span class="muted small">{t("admin.overview.noExperts")}</span>}
                <div class="divider" />
                <div class="row between small">
                  <span class="muted">{t("admin.overview.healthAttention")}</span>
                  <span class="tabular strong">{d.homes.attention + d.homes.critical}</span>
                </div>
                <div class="row between small">
                  <span class="muted">{t("admin.overview.unoccupied")}</span>
                  <span class="tabular strong">{d.homes.unoccupied}</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      ), 6)}
    </div>
  );
}
